<template>
    <div>


            <h2> Analysis </h2>
            <!-- @click="exportCsv" @click="downloadOutputs"-->
            <button v-show="Object.keys(responseData.data).length > 0" @click="exportCsv" class="btn btn-outline-secondary btn-sm mr-2">
                <i class="bi bi-file-earmark-spreadsheet"></i>
                Export CSV
            </button>

            <button v-show="Object.keys(responseData.data).length > 0" @click="exportImages" class="btn btn-outline-secondary btn-sm mr-2">
                <i class="bi bi-file-earmark-image"></i>
                Export images with measurements
            </button>

            <div class="table-container">
            <table border="1" class="main_table">

                <thead>
                <tr>
                  <th> File name </th>
                  <th> Mean </th>
                  <th> Standard deviation </th>
                  <th> Median </th>
                  <th> Unit </th>
                  <th> Results </th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for= "(value, key) in responseData.data">
                    <td> {{ key }}</td>
                    <td> {{ value.mean }}</td>
                    <td> {{ value.stdev }}</td>
                    <td> {{ value.median }}</td>
                    <td> {{ value.result_unit }}</td>
                    <td>
                        <b-button :style="{backgroundColor: '#605F5E'}" v-b-modal.modalPopover @click="showPlot(value.measurements); showImage(value.output_file_path)">Show results</b-button>
                    </td>
                    </tr>
                </tbody>
                </table>
                <b-modal v-model="showModal" title="Results" @hidden="clearPlot" class="custom-modal" size="xl" ok-only>
                    <b-tabs content-class="mt-3">
                        <b-tab title = "Histogram" active>
                            <div class="modal-content">
                        <Plotly v-if="showPlotComponent" :data="data" :layout="layout" :config="plotConfig"></Plotly></div>
                        </b-tab>
                        <b-tab title="Measurements on image">
                            <div class="modal-content">
                                
                                <img :src=outimagePath width="60%" height="60%" >
                            </div>
                        </b-tab>


                    </b-tabs>
                        
                </b-modal>

            </div>
    </div>
</template>

<script>


import _ from 'lodash';
import { Plotly } from 'vue-plotly';
import { saveAs } from 'file-saver';
import API from '../api';
import { BModal } from 'bootstrap-vue';

function formatDate(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    //hours = hours % 12;
    //hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    seconds = seconds < 10 ? '0'+seconds : seconds;
    var strTime = hours + '-' + minutes + '-' + seconds;

    var month = (date.getMonth()+1);
    month = month < 10 ? '0'+month : month;

    var day = date.getDate();
    day = day < 10 ? '0'+day : day;

    return date.getFullYear() + "-" + month + "-" + day + "_" + strTime;
}


export default {
    name: 'BatchResults',
    components: {
        Plotly, BModal
    },
    props: {
        responseData: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            backendURL:'/static',
            showModal: false,
            showPlotComponent: false,
            outimagePath: "", 
            data: [{
                x: [],
                type: 'histogram',
            }],

            layout: {
                xaxis: {title:'Measurements (nm)'},
                yaxis: {title: 'Frequency'},
                autosize: true,
                margin: { l: 50, r: 50, b: 50, t: 50, pad: 4 },
            },

            plotConfig: {
                displayModeBar: false,
                responsive: true
            },
        };
    },
    mounted() {

    },
    methods: {

    showPlot(data) {
      // Set showPlotComponent to true to render the Plotly component
      this.showPlotComponent = true;
      // Set showModal to true to show the BootstrapVue modal
      this.showModal = true;
      this.data[0].x = data
      //console.log(this.data)
    },

    showImage(imagePath){
        this.showPlotComponent=true
        this.showModal = true
        this.outimagePath= "http://localhost/"+_.join(_.split(imagePath, "/").slice(1), "/") //tmp fix
        console.log("output image path", this.outimagePath)
        //this.image = this.responseData.

    },

    clearPlot() {
      // Reset showPlotComponent when the modal is hidden
      this.showPlotComponent = false;
    },

    exportCsv() {
        let blob = new Blob([this.responseData.csv_table], {type: 'text/csv;charset=utf-8' })
        const formatted_date = formatDate(new Date())
        saveAs(blob, `results_${formatted_date}.csv`)
    },

    async exportImages() {
  
        // console.log(this.responseData.zip_path)
        const zipPath = this.responseData.zip_path
        console.log("this is the zip path", zipPath)
        API.download_zip({
            'path': zipPath
        })

        //console.log("these are the results", results)

        const response = await fetch('http://localhost/static/uploads/002f011350/output/measured_images.zip')
        // console.log("response", response)
        const blob = await response.blob();

        // console.log("blob", blob)
        // Create a temporary URL for the blob
        const blobUrl = window.URL.createObjectURL(blob);

        // Create a temporary anchor element
        const anchor = document.createElement('a');
        anchor.href = blobUrl;
        anchor.download = 'file.zip'; // Name of the downloaded file
        anchor.click();

        // Cleanup: Revoke the blob URL
        window.URL.revokeObjectURL(blobUrl);

        
        

        

        // // Create a temporary anchor element
        // const anchor = document.createElement('a');
        // anchor.href = window.URL.createObjectURL(blob);
        // anchor.download = zipPath;

        // // Trigger a click event on the anchor to initiate download
        // anchor.click();
        // Fetch the zip file as blob
        // const zipResponse = await fetch(zipPath);
        // console.log("this is the zipresponse", zipResponse)
        // const zipBlob = await zipResponse.blob();

        // // Create a temporary anchor element
        // const anchor = document.createElement('a');
        // anchor.href = window.URL.createObjectURL(zipBlob);
        // anchor.download = 'measured_images.zip';

        // // Trigger a click event on the anchor to initiate download
        // anchor.click();
        
        // catch (error) {
        //     console.error('Error downloading images:', error);
        // }

        // const response = axios.get(`http://localhost/api/download_zip/${filePath}`, { responseType: 'blob' });

        // const zipBlob = new Blob([response.data], { type: 'application/zip' });

        // // Create a download link
        // const link = document.createElement('a');
        // link.href = window.URL.createObjectURL(zipBlob);
        // link.download = 'archive.zip';

        // // Append the link to the body
        // document.body.appendChild(link);

        // // Trigger a click on the link to start the download
        // link.click();

        // // Remove the link from the DOM
        // document.body.removeChild(link);

        // var zip = new JSZip()
        // zip.folder(filePath)
        // zip.generateAsync({type:"blob"})
        // .then (function(content) {
        //     saveAs(content, "example.zip")



       // Fetch the ZIP file from the server using the file path
       // const response = axios.get('http://localhost/api/analyze');


        // const link = document.createElement('a');
        
        // // Create a Blob object from the response data
        // // const zipBlob = new Blob([response.data], { type: 'application/zip' });
        exportC
        // // Create a download link
        // // const link = document.createElement('a');

        //   link.href = filePath
        //   link.download = filePath;

        //   // Append the link to the body
        //   document.body.appendChild(link);

        //   // Trigger a click on the link to start the download
        //   link.click();

        //   // Remove the link from the DOM
        //   document.body.removeChild(link);

    },
        
        // console.log(this.responseData.data["EcN_II_PEO_131120_GML_15k_01.tif"])
        // Object.keys(this.responseData.output_files)
    //     try {
    //     var imagePaths = this.responseData.output_files
    //     console.log(imagePaths)

    //     // Promise.all(imagePaths.map((imagePath, index) => {
    //     //   try {
    //     //     const response = axios.get(imagePath, { responseType: 'arraybuffer' });
    //     //     const imageBlob = new Blob([response.data]);
    //     //     zip.file(`image${index + 1}${getExtension(imagePath)}`, imageBlob);
    //     //   } catch (error) {
    //     //     console.error(`Error fetching image: ${imagePath}`, error);
    //     //   }
    //     // }));
    //     // const zipBlob = zip.generateAsync({ type: 'blob' });

    //     // const formatted_date = formatDate(new Date())
    //     // // Use the file-saver saveAs function to save the zip file
    //     // saveAs(zipBlob, `images_w_measurements_${formatted_date}.zip`);
    // }
    // catch (error) {
    //     console.error('Error fetching image paths:', error);
    //   }

    

    // handleModalShown() {
    //   // This method is called when the modal is shown
    //   // Use Plotly.relayout to update the plot layout
    //   Plotly.relayout('myDiv', this.layout);
    // },




        // exportCsv() {

        //     let customHeader = this.gridOptions.columnApi.getAllColumns()
        //         .map(col => col.colDef.field)
        //         .join(',');

        //     let exportParams = {
        //         fileName: "results_" + formatDate(new Date()),
        //         columnKeys: this.gridOptions.columnApi.getAllColumns().map(col => col.colId),
        //         processCellCallback: (params) => params.value,
        //         customHeader: customHeader,
        //         skipHeader: true,
        //     };

        //     this.gridOptions.api.exportDataAsCsv(exportParams);

        // },
        // // resetFilters() {
        // //     this.gridOptions.api.setFilterModel(null);
        // //     this.gridOptions.api.onFilterChanged();
        // //     this.isFiltered = false;
        // // },
        // parseCSVData(csvData) {
        //     return new Promise((resolve) => {
        //         csv.parse(csvData, {
        //             header: true,
        //             dynamicTyping: true,
        //             skipEmptyLines: true,
        //             complete: (results) => {
        //                 resolve(results.data);
        //             }
        //         });
        //     });
        // },
        // async processData() {
        //     const csvData = this.responseData.data;
        //     if (csvData) {
        //         const parsedData = await this.parseCSVData(csvData);
        //         if (parsedData.length > 0) {
        //             this.columnDefs = this.generateColumnDefs(parsedData);
        //             this.rowData = parsedData;
        //         }
        //     }
        // },

    },
    watch: {
        // rowData() {
        //     this.renderPlot();
        // },
        // cdf() {
        //     this.renderPlot();
        // },
        // resultsData: {
        //     handler() {
        //         this.processData();
        //     },
        //     immediate: true
        // }
    }
}
</script>

<style scoped>

.table-container {
  max-height: 500px; /* Set the maximum height for the table */
  max-width: 100%;
  overflow-y: auto; /* Enable vertical scrolling if needed */
  padding-right: 10px;
  margin-top: 20px;
  padding:0px;
  border-width: 0px;
}

td,
th {
    padding: 10px 20px 10px 20px;
    text-align: center;
    position: relative;
}

.img {
    width: 60%;
    height: 60%
}
.batch-results {
    width: 100%;
}

.custom-modal {
  /* Example styles, modify as needed */
  background-color: #f0f0f0;
  border: 2px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 90%;
  margin: 0 auto;
  padding: 20px;
  color: #333;

}

/* Custom styling for modal content container */
.modal-content{
  display: flex;
  align-items: center;      /* Center vertically */
  justify-content: center;  /* Center horizontally */
  height: 100%;             /* Full height of the container */
  width: 100%
}

div.tooltip-plot {
    position: absolute;
    text-align: left;
    padding: .5rem;
    background: #FFFFFF;
    color: #313639;
    border: 1px solid #313639;
    border-radius: 8px;
    pointer-events: none;
    font-size: 12px;
}
</style>


<style>

.axis path,
.axis line {
    fill: none;
    stroke: #000;
    shape-rendering: crispEdges;
}

/*.x.axis path {
    display: none;
}*/
.line {
    fill: none;
    stroke: lightgrey;
    stroke-width: 3px;
}

</style>
